import React from 'react';
import ReactDom from 'react-dom';
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { SgiEventHandler } from './SgiEventHandler';
import { MediaResourceCode } from 'rt-sd-common/sgiFactory/MediaResourceCode'
import ReactEcharts from 'echarts-for-react';


class SgiEchartLine extends React.Component {

    static defaultProps = {
    };
    static props = {
    };

    constructor(props) {
        super(props);
        //初始化state
        this.state = {
            echartprops: {
                style: {}
            },
            functions: {},
        }
    }



    /**
    * @param {父组件} parentModule
    * @param {组件描述} moduleDesc
    * @param {绑定实例ID} bdInst
    * @param {对象工厂} objFct
    * @param {make类型} type
    */
    echart_mk(parentModule, moduleDesc, bdInst, objFct, type) {
        if (!moduleDesc) {
            return;
        }
        this.AddechartAttribute(moduleDesc, this.state.echartprops);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.echartprops, this.state.functions, type);
    }
    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} treeProps
     */
    bindEvent(moduleDesc, echartprops, functions, type) {
        //拖拽模式 不生成事件
        if (type == 'dnd') {
            return;
        }
        var eck = moduleDesc.clkLsn; // 用户自定义点击事件
        if (eck) {
            var $eck = new Function("module", "objFct", eck);
            functions.onClick = $eck;
            echartprops.onClick = SgiEventHandler.onClick.bind(this);
        }

    }
    AddechartAttribute(moduleDesc, echartprops) {
        //显示图片
        var scId = moduleDesc.scId;
        if (scId) {
            var url = MediaResourceCode.getPrmUrl(scId);
            if (url) {
                echartprops.src = url;
            }
        } else {
            var disply = moduleDesc.disply;
            if (disply) {
                echartprops.src = disply;
            }
        }

        var show = moduleDesc.alt;
        if (show) {
            echartprops.alt = show;
        }
        //图片的大小设置
        var ctlH = moduleDesc.ctlH;
        if (ctlH) {
            echartprops.style.height = ctlH;
        }
        var ctlW = moduleDesc.ctlW;
        if (ctlW) {
            echartprops.style.width = ctlW;
        }


        this.state.echartprops = {
            title: {
                text: 'ECharts 入门示例'
            },
            tooltip: {},
            xAxis: {
                type: 'category',
                data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [820, 932, 901, 934, 1290, 1330, 1320],
                type: 'line'
            }]
        }
    }


    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    render = function () {
        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            this.echart_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }
        return (
            <div style={{ height: '100%', width: '100%' }}>
                <ReactEcharts
                    option={this.state.echartprops}
                />
            </div>


        );
    }
}
export { SgiEchartLine };
export default SgiEchartLine;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiEchartLine.js